var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppContentDetails',{staticClass:"app-content"},[_c('NcEmptyContent',{staticClass:"app-content__empty",attrs:{"name":_vm.welcomeMessage},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconMail',{attrs:{"size":65}})]},proxy:true}])}),_vm._v(" "),_c('NewMessageButtonHeader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }